<template>
<div>
  <a href="javascript:;" @click="switchLang('en')" v-if="locale !== 'en'">English</a>
  <a href="javascript:;" @click="switchLang('fr')" v-if="locale !== 'fr'">Français</a>
</div>
</template>

<script>

export default {
  data () {
    return {
      locale: locale,
    }
  },
  mounted () {
  },
  methods: {
    switchLang: function(lang) {
      let self = this;
      self.$http.post("/api/v1/util/locale", { lang: lang }).then(
        function(response) {
          location.reload();
        },
        function(error) {
          console.error(error);
          self.err = [error.response.data];
        }
      )
    },
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/LanguageSwitch.vue